import styled from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const DomainTitle = styled.span`
    margin-right: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    ${setFontVariant("h4", carbon[500])};

    @media (min-width: 1280px) {
        max-width: 405px;
    }
    @media (min-width: 1440px) {
        max-width: 545px;
    }
`;

export const NoResult = styled(FlexRow)`
    ${setFontVariant("body2")};
    height: 76px;
    align-items: center;
    padding-left: 16px;
`;

export const TitleWrapper = styled.div`
    position: relative;
    display: flex;
`;

export const IconWrapper = styled(FlexRow)`
    width: 32px;
    height: 32px;
    margin-right: 16px;
    align-items: center;
    justify-content: center;
    border: 1px solid ${colorsPalettes.carbon[100]};
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0px 2px 4px ${rgba(colorsPalettes.carbon[500], 0.2)};
`;
